import type { PhaseId, PhaseStatus } from '@wedpo/soc2';
import { PHASES } from '@/lib/store';

const STATUS_LABEL: Record<string, { cls: string; label: string }> = {
  done: { cls: 'donest', label: 'Complete' },
  active: { cls: 'open', label: 'In progress' },
  locked: { cls: 'lockst', label: 'Locked' },
};

export function Journey({
  phaseStatus,
}: {
  phaseStatus: Record<PhaseId, PhaseStatus>;
}) {
  return (
    <section>
      <p className="eyebrow">The path</p>
      <h1 className="title">Phase map</h1>
      <p className="sub">
        Progressive unlock - finishing a phase opens the next. An admin can unlock any
        phase manually.
      </p>
      {PHASES.map((p) => {
        const status = phaseStatus[p.id];
        const meta = STATUS_LABEL[status];
        return (
          <div key={p.id} className={`phase ${status === 'locked' ? 'lock' : status}`}>
            <div className="pn">{p.n}</div>
            <div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </div>
            <span className={`st ${meta.cls}`}>{meta.label}</span>
          </div>
        );
      })}
    </section>
  );
}
